import { module } from 'modujs'
import { $body } from '../utils/dom'

export default class extends module {
  constructor(m) {
    super(m)

    this.result = this.el.querySelector('.c-co2_value_label')
    this.value = 0.00
    this.kgPS = Number.parseFloat(this.el.getAttribute('data-value')) // kg CO2 / second

    this.updateInterval = null
    this.intervalDuration = 5000

    this.today = new Date()
    this.today.setHours(
      0,
      0,
      0,
      0
    )

    this.odometer = null
  }

  initialize(_, force = false) {
    if (this.odometer || ($body.classList.contains('home') && force === false))
      return

    /* global Odometer */
    this.odometer = new Odometer({
      el: this.result,
      value: '0.00',
      theme: 'minimal',
      format: '( ddd).dd',
      duration: 1000
    })
    this.odometer.render()

    this.value = this.getProgress()
    this.result.textContent = this.value

    this.updateInterval = setInterval(() => {
      this.value = this.getProgress()
      this.odometer.update(this.value)
    }, this.intervalDuration)
  }

  show() {
    this.el.classList.add('-visible')
    this.initialize(null, true)
  }

  getProgress() {
    const difference = this.getSecondsDiffBetweenDates(this.today, new Date())

    return (difference * this.kgPS / 1000000).toFixed(2)
  }

  getSecondsDiffBetweenDates(dateInitial, dateFinal) {
    return (dateFinal - dateInitial) / 1000
  }

  destroy() {
    clearInterval(this.updateInterval)

    this.odometer?.stopWatchingMutations()
    this.odometer?.resetDigits()
  }
}
